// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-comp-template-js": () => import("/home/travis/build/Torob/react-common/docs/src/templates/comp-template.js" /* webpackChunkName: "component---src-templates-comp-template-js" */),
  "component---src-pages-404-js": () => import("/home/travis/build/Torob/react-common/docs/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/home/travis/build/Torob/react-common/docs/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

